import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/24/outline";
import { ReactNode } from "react";

interface HeaderProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  rightElement?: ReactNode;
}

export const Header = ({
  isCollapsed,
  onToggleCollapse,
  rightElement,
}: HeaderProps) => {
  return (
    <div
      className={`sticky top-0 flex h-[62px] w-full items-center border-b border-zinc-300 bg-white transition-all duration-300 ${isCollapsed ? "justify-center px-2" : "justify-between px-6"}`}
    >
      {!isCollapsed && (
        <div className="text-base font-bold leading-tight text-black">
          Mentorship Details
        </div>
      )}
      <div className="flex items-center gap-2">
        {!isCollapsed && rightElement}
        <button
          onClick={onToggleCollapse}
          className="flex size-8 items-center justify-center rounded-md text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
        >
          {isCollapsed ? (
            <ChevronDoubleRightIcon className="size-5" />
          ) : (
            <ChevronDoubleLeftIcon className="size-5" />
          )}
        </button>
      </div>
    </div>
  );
};
